export default {
  Email: 'Correo electrónico',
  ConfirmEmail: 'Confirmar correo electrónico',
  Password: 'Contraseña',
  Verificationcode: 'Código de verificación',
  AlreadyhaveaHitPawaccountLogin: '¿Ya tiene una cuenta HitPaw? Iniciar sesión',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
    'Al registrarte, aceptas nuestros Servicios de Uso y Política de Privacidad',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
    'Al iniciar sesión, acepta nuestro Servicio de Uso y Política de Privacidad',
  Byproceedingyouagreetoour:
    'Al registrarte/Al iniciar sesión, acepta nuestro ',
  ServicesofUse: 'Servicio de Uso',
  and: ' y ',
  PrivacyPolicy: 'Política de Privacidad',
  last: '.',
  TheEmailformatisincorrect: 'El formato del correo electrónico es incorrecto',
  Pleaseenterthesameemailinbothfields:
    'Por favor, introduzca el mismo correo electrónico en ambos campos.',
  Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
    'La contraseña debe tener entre 8 y 50 caracteres y contener al menos dos categorías entre las siguientes: número, letra o carácter especial.',
  Incorrectverificationcode: 'Código de verificación incorrecto',
  ThisEmailhasbeenregisteredpleasechooseanother:
    'Este E-mail ha sido registrado, por favor elija otro.',
  Cannotbeemptyhere: 'No puede estar vacío aquí.',
  Rememberme: 'Recordarme',
  ForgotPassword1: '¿Olvidó su contraseña?',
  NotaregistereduseryetSignUp: '¿Aún no es un usuario registrado? Regístrese',
  Notaregistereduseryet1: '¿Aún no es un usuario registrado? ',
  Notaregistereduseryet2: 'Regístrese',
  NoaccountfoundwiththatEmailaddress:
    'No se ha encontrado ninguna cuenta con esa dirección de correo electrónico',
  YourEmailaddressorpasswordwasincorrectPleasetryagain:
    'Su dirección de correo electrónico o su contraseña son incorrectas. Por favor, inténtelo de nuevo.',
  ForgotPassword2: 'Olvidé mi contraseña',
  GetVerificationCode: 'Obtener código de verificación',
  VerifyEmail: 'Verificar correo electrónico',
  Ithasbeensenttoyourmailboxpleasecheckit:
    'Se ha enviado a su buzón de correo, por favor, compruébelo',
  PleaseinputEmailaddress:
    'Por favor, introduzca la dirección de correo electrónico',
  TheEmailisnotregistered: 'El correo electrónico no está registrado',
  Invalidverificationcodepleasereenterthecorrectone:
    'El código de verificación no es válido, por favor, vuelva a introducir el correcto',
  Resetpassword: 'Restablecer la contraseña',
  Emailaddressverificationsucceeded:
    'La verificación de la dirección de correo electrónico se ha realizado con éxito',
  Pleaseresetyourpassword: 'Por favor, restablezca su contraseña',
  Enteranewpassword: 'Introduzca una nueva contraseña',
  Confirm: 'Confirme',
  Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
    'La nueva contraseña debe tener entre 8 y 50 caracteres, compuestos por letras o números o una mezcla de letras + números',
  Passwordresetsuccessfully: 'Contraseña restablecida con éxito',
  Name: 'Nombre',
  GetCode: 'Obtener Código',
  Loginsuccessful: 'Iniciar sesión con éxito',
  Loginfailed: 'Error de iniciar sesión',
  Signupsuccessful: 'Registro exitoso',
  Signupfailed: 'Registro fallido',
  Getpassword: 'Obtener contraseña',
  Authorizationhasexpiredpleaseloginagain:
    'La autorización ha caducado, por favor vuelva a iniciar sesión',
  Sorrysomethingwentwrongpleasetryagainlater:
    'Disculpe, algo salió mal, por favor intente de nuevo más tarde',
  Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
    'Se realizaron demasiados pedidos en poco tiempo, intente de nuevo más tarde',
  Couldntfindyouraccountorthepasswordisincorrect:
    'No se encontró su cuenta o la contraseña es incorrecta',
  Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
    'Está intentando acceder a una función de pago, por favor regístrese primero',
  Accessdeniedfortheunauthorizedrequest:
    'Acceso denegado por solicitud no autorizada',
  Alreadyhaveaccount: '¿Ya tienes una cuenta?',
  SignUpwithemail: 'Registro por correo electrónico',
  Securityverification: 'Verificación de la seguridad',
  Pleaseenterthecorrectemailaddress:
    '¡Escribe la dirección de correo electrónico correcta!',
  PleaseInputverificationCode:
    '¡Por favor, introduzca el Código de verificación!',
  Pleaseenterthesamepasswordinbothfields:
    '¡Por favor escribe la misma contraseña en dos veces!',
  or: 'O',
  ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
    'La nueva contraseña introducida es la misma que la anterior. Introduzca una contraseña diferente',
  YourpasswordwasincorrectPleasetryagain:
    'Su contraseña es incorrecta. Inténtelo de nuevo.',
  reg400: 'Disculpe, algo salió mal, por favor intente de nuevo más tarde',
  reg400223:
    'El correo electrónico y el código no se corresponden, por favor compruébelos.',
  reg400224: 'La Token ha pasado el plazo.',
  500: '¡Error del lado del servidor!',
  Afewsecondsaway: 'Inicia o regístrate en unos segundos',
  ContinuewithGoogle: 'Continuar con Google',
  ContinuewithEmail: 'Continuar con el correo electrónico',
  LoginwithEmail: 'Iniciar con el correo electrónico',
  Usemorethan8charactersandmixlettersnumbersandsymbols:
    'Utiliza más de 8 caracteres y una mezcla de letras, números y símbolos (Símbolos admitidos: @$! %*#_~? &^)',
  ConfirmPassword: 'Confirmar Contraseña',
  Pleaseloginwithemail: 'Por favor inicia con el correo electrónico',
  youraccount: 'Tu cuenta',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'ya existe. Para garantizar la seguridad de la cuenta, por favor, realiza primero la verificación de seguridad.',
  Login: 'Ingresar',
  exceed6Times:
    'Su versión de prueba se agotó hoy, actualice a Pro para acceder a todas las funciones premium.',
  exceed20M:
    'El tamaño del archivo para cuentas gratuitas no puede exceder los 20 MB, actualice a Pro para acceder a todas las funciones premium.',
  403102: 'La cuenta de Google ha sido vinculada a otra cuenta.',
};
